module.exports = __webpack_public_path__ + "static/media/thumbnail-peronteto-acel-szerkezet.28a71e38.jpg";